import { Link, useParams } from "react-router-dom";
import { useGetSingleCreditManagementQuery } from "hooks/CreditManagement/useGetSingleCreditManagementQuery";
import DashboardLayout from "Layout/DashboardLayout";
import Loader from "Components/Loader";
import Header from "./Header";
import NairaSign from "Components/NairaSign";
import Scaffold from "Components/Scaffold";
import Moment from "react-moment";
import KoboConverter from "Components/KoboConverter";
import NairaValue from "Components/NairaValue";

const SingleCreditManagement = () => {
  const { id } = useParams();
  const { data, isPending } = useGetSingleCreditManagementQuery(`${id}`);
  const emptyCredit = require("../../../assets/emptycredit.png");

  return (
    <DashboardLayout title="Credit Management" back={false}>
      <div className="p-6">
        {isPending && <Loader />}
        {!isPending && data?.data && (
          <div>
            <Header />

            <div className="grid grid-cols-2 gap-6">
              <div className="space-y-4">
                <UserCard
                  data={data}
                  user={data.data.user}
                  creditRequested={data.data.amount}
                />
                <ReasonForApplication reason={data.data.reason} />
                <ActivityLog logs={data.data.logs} />
              </div>
              <div className="space-y-4">
                <RepaymentSection data={data?.data} emptyCredit={emptyCredit} />
              </div>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

const UserCard = ({ data, user, creditRequested }: any) => (
  <div className="">
    <div className="flex items-center space-x-4">
      <div>
        <h3 className="text-lg font-semibold">
          {`${user.firstName} ${user.lastName}`}{" "}
          <span
            className={`ml-3 px-2 py-1 rounded-lg text-sm text-white ${
              data?.data?.status === "approved"
                ? "bg-green-500"
                : data?.data?.status === "in_review"
                ? "bg-blue-500"
                : data?.data?.status === "declined"
                ? "bg-red-500"
                : data?.data?.status === "repaid"
                ? "bg-orange"
                : data?.data?.status === "pending"
                ? "bg-ash"
                : ""
            }`}
          >
            {data?.data?.status === "pending" && "Pending"}
            {data?.data?.status === "in_review" && "In Review"}
            {data?.data?.status === "declined" && "Declined"}
            {data?.data?.status === "repaid" && "Repaid"}
            {data?.data?.status === "approved" && "Approved"}
          </span>
        </h3>

        <div className="flex items-center space-x-2"></div>
        <div className="text-sm text-gray-500 mt-3 text-primary-foreground">
          <div>Customer ID: #{user.id}</div>
          <div>
            Total Orders:{" "}
            {data?.data?.totalOrders ? data?.data?.totalOrders : "n/a"}
          </div>
          {/* <div>
            Total Amount:{" "}
            {data?.data?.amount ? data?.data?.amount.toLocaleString() : "n/a"}
          </div> */}
        </div>
      </div>
    </div>
    <div className="my-4 bg-primary-light rounded-[10px] p-[24px]">
      <div className="border-l-[5px] border-orange flex items-center justify-between">
        <span className="ml-[5px] text-black">Credit Requested</span>
        <span className="font-bold">
          <KoboConverter amount={creditRequested} />
          <br />
        </span>
      </div>
    </div>
    <Scaffold
      left="Customer’s Information"
      right={
        <Link
          to={`/customer-management/${data?.data?.user?.id}`}
          className="text-orange font-medium"
        >
          View Profile
        </Link>
      }
    >
      <div className="px-3">
        <div className="flex items-center mb-2">
          <div className="w-4/12 text-primary-foreground">Email</div>
          <div className="w-8/12 flex-wrap">
            {data?.data?.user?.email ? data?.data?.user?.email : "n/a"}
          </div>
        </div>
        <div className="flex items-center mb-2">
          <div className="w-4/12 text-primary-foreground">Phone</div>
          <div className="w-8/12 flex-wrap">
            {data?.data?.user?.businessAddress?.phoneNumber
              ? data?.data?.user?.businessAddress?.phoneNumber
              : "n/a"}
          </div>
        </div>
        <div className="flex items-center mb-2">
          <div className="w-4/12 text-primary-foreground">Gender</div>
          <div className="w-8/12 flex-wrap">
            {data?.data?.user?.gender ? data?.data?.user?.gender : "n/a"}
          </div>
        </div>
        <div className="flex items-center mb-2">
          <div className="w-4/12 text-primary-foreground">Nationality</div>
          <div className="w-8/12 flex-wrap">
            {data?.data?.user?.nationality
              ? data?.data?.user?.nationality
              : "n/a"}
          </div>
        </div>
      </div>
    </Scaffold>
  </div>
);

const ReasonForApplication = ({ reason }: any) => (
  <Scaffold left="Reason for Application">
    <div className="px-3 text-primary-foreground">
      {reason ? reason : "n/a"}
    </div>
  </Scaffold>
);

const ActivityLog = ({ logs }: any) => (
  <Scaffold left="Activity Log">
    <div className="px-3">
      {logs &&
        logs.map(({ status, comment, createdAt, id, updatedBy }: any) => (
          <div key={id} className="mb-4">
            <h3
              className={`font-bold text-black ${
                status === "approved"
                  ? "text-green-500"
                  : status === "in_review"
                  ? "text-blue-500"
                  : status === "declined"
                  ? "text-red-500"
                  : status === "repaid"
                  ? "text-orange"
                  : status === "pending"
                  ? "text-ash"
                  : ""
              }`}
            >
              {status === "pending" && "Pending"}
              {status === "in_review" && "In Review"}
              {status === "declined" && "Declined"}
              {status === "approved" && "Approved"}
            </h3>
            <p className="mb-1">Comment: {comment}</p>
            <p className="mb-3">
              Updated by: {updatedBy?.firstName ? updatedBy?.firstName : ""}
              {updatedBy?.lastName ? updatedBy?.lastName : ""}
            </p>
            {/* <div>
              By: <span className="text-orange">{id}</span>
            </div> */}
            <div className="text-primary-foreground">
              <Moment interval={0} format="DD-MM-YYYY hh:mm a">
                {createdAt}
              </Moment>
            </div>
          </div>
        ))}
    </div>
  </Scaffold>
);

const RepaymentSection = ({ data, emptyCredit }: any) => (
  <div className="">
    <Scaffold
      left="Repayment"
      // right={<button className="text-orange font-medium">Add payment</button>}
    >
      <div className="px-2">
        <div className="grid grid-cols-2 gap-4 text-sm">
          <div>Amount Paid</div>
          <div className="text-ash">
            <KoboConverter amount={data?.amountPaid} />
          </div>
          <div>Remaining Balance</div>
          <div className="text-ash">
            <KoboConverter amount={data?.amount - data?.amountPaid} />
          </div>
          <div>Payment Status</div>
          <span>
            <span
              className={`inline capitalize px-2 py-1 rounded-lg text-sm text-white ${
                data?.data?.isPaid === true ? "bg-green-500" : "bg-yellow-500"
              }`}
            >
              {data?.data?.isPaid === true ? "Paid" : "Un Paid"}
            </span>
          </span>
        </div>
      </div>
    </Scaffold>

    {/* <Scaffold left="Payment History">
      <div className="px-2"></div>
    </Scaffold> */}
    <Scaffold left="Payment History">
      <div className="px-2">
        <div className="mt-4 space-y-2 text-sm">
          {data?.paymentLogs && data?.paymentLogs.length > 0 ? (
            data?.paymentLogs.map(
              ({ id, amount, amountRemaining, createdAt }: any) => (
                <div key={id} className="mb-4">
                  <div className="mb-2">
                    <Moment interval={0} format="DD-MM-YYYY hh:mm a">
                      {createdAt}
                    </Moment>
                  </div>
                  <p className="text-ash ">
                    Paid:
                    <KoboConverter amount={amount} />
                  </p>
                  <p className="text-ash mb-1">
                    Remaining:
                    <KoboConverter amount={amountRemaining} />
                  </p>
                </div>
              )
            )
          ) : (
            <img
              src={emptyCredit}
              alt="empty"
              className="flex mx-auto pb-[40px] w-[300px]"
            />
          )}
        </div>
        {data?.data?.isPaid === false && (
          <div className="mt-6 text-gray-500 text-sm">
            This customer's repayment is still ongoing
          </div>
        )}
      </div>
    </Scaffold>
  </div>
);

export default SingleCreditManagement;
